import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import scholar1 from "../../images/scholar1.png";
import scholar2 from "../../images/scholar2.png";
import scholar3 from "../../images/scholar3.png";
import zoom from "../../images/aboutzoom.png";
import insta from "../../images/aboutinsta.png";
import twitter from "../../images/abouttwitter.png";

const Scholars = () => {
  return (
    <div className="QL__Sec__Scholars">
    
        <Container>
         
            <div className="QL__Sec__Scholars__Heading">
              <h1 className="HeadingAll">
                Our Scholar Whose Knowledge Is Useful <br />For 
                Others
              </h1>
            </div>
            <Grid container  spacing={2} justifyContent="center">
              <Grid item xs={12} sm={6} md={4} textAlign="center">
                <Card
                  className="QL__Sec__Scholars__Cards"
                  sx={{  width: 1}}
                >
                  <CardContent>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      <img
                        className="QL__Sec__Scholar__IMGS"
                        src={scholar1}
                      ></img>
                    </Typography>
                  
                      <br />
                  
                    <Typography
                      sx={{ mb: 1.5 }}
                      variant="h5"
                      justifyContent="center"
                      fontWeight={600}
                    >
                      Hamid Bin Jasim
                    </Typography>
                    <Typography variant="h7" fontWeight={550}>
                      Hafiz Quran School
                    </Typography>
                    <div className="links">
                    <a href="#">
                          <i class="fab fa-linkedin-in"><img src={zoom}/></i>
                        </a>
                        <a href="#">
                          <i class="fab fa-twitter"><img src={twitter}/></i>
                        </a>
                        <a href="#">
                          <i class="fab fa-instagram"><img src={insta}/></i>
                        </a>
                        
                      </div>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={4} textAlign="center">
                <Card
                  className="QL__Sec__Scholars__Cards"
                  sx={{  width: 1}}
                  
                  justifyContent="center"
                >
                  <CardContent>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      <img
                        className="QL__Sec__Scholar__IMGS"
                        src={scholar2}
                      ></img>
                    </Typography>
                    <br />
                    <Typography
                      sx={{ mb: 1.5 }}
                      variant="h5"
                      justifyContent="center"
                      fontWeight={600}
                    >
                      Taiyaba Ejaz
                    </Typography>
                    <Typography variant="h7" fontWeight={550}>
                      Hafiz Quran School
                    </Typography>
                    <div class="links">
                    <a href="#">
                          <i class="fab fa-linkedin-in"><img src={zoom}/></i>
                        </a>
                        <a href="#">
                          <i class="fab fa-twitter"><img src={twitter}/></i>
                        </a>
                        <a href="#">
                          <i class="fab fa-instagram"><img src={insta}/></i>
                        </a>
                        
                      </div>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={4} textAlign="center">
                <Card
                  className="QL__Sec__Scholars__Cards"
                  sx={{  width: 1}}
                  justifyContent="center"
                >
                  <CardContent>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      <img
                        className="QL__Sec__Scholar__IMGS"
                        src={scholar3}
                      ></img>
                    </Typography>
                    <br />

                    <Typography
                      sx={{ mb: 1.5 }}
                      variant="h5"
                      justifyContent="center"
                      fontWeight={600}
                      
                    >
                      Female Tutors
                    </Typography>
                    <Typography variant="h7" fontWeight={550}>
                      Hafiz Quran School
                    </Typography>
                    <div class="links">
                    <a href="#">
                          <i class="fab fa-linkedin-in"><img src={zoom}/></i>
                        </a>
                        <a href="#">
                          <i class="fab fa-twitter"><img src={twitter}/></i>
                        </a>
                        <a href="#">
                          <i class="fab fa-instagram"><img src={insta}/></i>
                        </a>
                        
                      </div>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
         
        </Container>
      
    </div>
  );
};

export default Scholars;
